import Vue from 'vue'
import $bizConfig from '@/models/bizConfig.js';
import $web3js from '../web3.js';
import $erc20 from '../erc20/index.js';
import $utils from "@/lib/utils/index.js";

const contractInfo = require('./dmexLend.json')

let web3 = $web3js.getWeb3();

let contractAddress = $bizConfig.dmexLendrContractAddress;
let contractConst = {
    contract: web3 ? new web3.eth.Contract(contractInfo.abi, contractAddress) : '',
}

const getDmexLendAddress = () => {
    return contractAddress;

}

const getDmexLendContract = () => {
    return contractConst.contract;
}

const getDmexLendNftInfo = ([_tokenid], options) => {
    return $web3js.call(getDmexLendContract().methods.getNftInfo, [_tokenid], options);

}

const DmexcalcHalfHourInterest = ([_tokenid], options) => {
    return $web3js.call(getDmexLendContract().methods.calcHalfHourInterest, [_tokenid], options, handHalfHourInterest);

}
const handHalfHourInterest = async(res) => {
    //uint256     Interest;
    //uint256     principal;
    //uint256     pledgeDmcAmount;
    let index = 0;
    let HalfHourInterest = res[index++];
    HalfHourInterest = await $erc20.fromErc20Value(HalfHourInterest, $erc20.getErc20Address("HFIL"));

    return {
        HalfHourInterest
    }
}

const DmexLendwithdrawRemainBenefit = ([_tokenid], options, callback) => {

    return $web3js.send(getDmexLendContract().methods.withdrawRemainBenefit, [_tokenid], options, callback);

}

const DmexLendwithdrawRemainBenefitEstimate = async([_tokenid], options) => {
    console.log(_tokenid)
    let gasPromise = $web3js.estimateSend(getDmexLendContract().methods.withdrawRemainBenefit, [_tokenid], options);
    console.log(gasPromise)
    let gasPricePromise = $web3js.getGasPrice();

    let [e1, gas] = await $utils.awaitWrap(gasPromise);
    let [e2, gasPrice] = await $utils.awaitWrap(gasPricePromise);
    if (!!e1) {
        Vue.prototype.$toast(e1 && e1.message ? e1.message : e1);
        return null;
    }

    let fee = $web3js.fromWei(Vue.prototype.$numberUtils.mul(gasPrice, gas));
    return { gas, gasPrice, fee };
}

const getDmexLendAutopayRemainBenefit = ([_tokenid], options) => {
    return $web3js.call(getDmexLendContract().methods.getAutopayRemainBenefit, [_tokenid], options, handDmexLendAutopayRemainBenefit);

}
const handDmexLendAutopayRemainBenefit = async(res) => {
    return await $erc20.fromErc20Value(res, $erc20.getErc20Address("HFIL"));
}

const getDmcRepayInfos = ([_tokenids], options) => {
    return $web3js.call(getDmexLendContract().methods.getRepayInfos, [_tokenids], options, handRepayInfos);
}

const handRepayInfos = async(res) => {

    let index = 0;
    let repayCapitalSum = res[index++];
    let repayInterestSum = res[index++];
    let totalPledgeDmcSum = res[index++];
    let remainPledgeDmcSum = res[index++];
    let availDmcSum = res[index++];
    let pledgeFilSum = res[index++];
    repayCapitalSum = await $erc20.fromErc20Value(repayCapitalSum, $erc20.getErc20Address("HFIL"));
    repayInterestSum = await $erc20.fromErc20Value(repayInterestSum, $erc20.getErc20Address("HFIL"));
    totalPledgeDmcSum = await $erc20.fromErc20Value(totalPledgeDmcSum, $erc20.getErc20Address("DMC"));
    remainPledgeDmcSum = await $erc20.fromErc20Value(remainPledgeDmcSum, $erc20.getErc20Address("DMC"));
    availDmcSum = await $erc20.fromErc20Value(availDmcSum, $erc20.getErc20Address("DMC"));
    pledgeFilSum = await $erc20.fromErc20Value(pledgeFilSum, $erc20.getErc20Address("HFIL"));

    return {
        repayCapitalSum,
        repayInterestSum,
        totalPledgeDmcSum,
        remainPledgeDmcSum,
        availDmcSum,
        pledgeFilSum
    }
}


const getDmexLendPoolInfo = (options) => {
    return $web3js.call(getDmexLendContract().methods.getPoolInfo, [], options, handlePoolInfo);
}

const handlePoolInfo = async(res) => {
    //uint256 totalLendFilAmount;
    // console.log(res)
    let index = 0;
    let totalLendFilAmount = res[index++];

    totalLendFilAmount = await $erc20.fromErc20Value(totalLendFilAmount, $erc20.getErc20Address("HFIL"));

    return {
        totalLendFilAmount
    }
}

// const DmexLendpledge = async([_dminer, _prodid, _oldTokenid], options, callback) => {
//     return $web3js.send(getDmexLendContract().methods.pledge, [_dminer, _prodid, _oldTokenid], options, callback);
// }

// const DmexLendpledgeEstimateSend = async([_dminer, _prodid, _oldTokenid], options) => {
//     let gasPromise = $web3js.estimateSend(getDmexLendContract().methods.pledge, [_dminer, _prodid, _oldTokenid], options);
//     let gasPricePromise = $web3js.getGasPrice();

//     let [e1, gas] = await $utils.awaitWrap(gasPromise);
//     let [e2, gasPrice] = await $utils.awaitWrap(gasPricePromise);
//     if (!!e1) {
//         Vue.prototype.$toast(e1 && e1.message ? e1.message : e1);
//         return null;
//     }

//     let fee = $web3js.fromWei(Vue.prototype.$numberUtils.mul(gasPrice, gas));
//     return { gas, gasPrice, fee };
// }

// const DmexLendpledgeNtfs = async([nftlist], options, callback) => {
//     return $web3js.send(getDmexLendContract().methods.pledgeNtfs, [nftlist], options, callback);
// }

// const DmexLendpledgeNtfsEstimateSend = async([nftlist], options) => {
//     let gasPromise = $web3js.estimateSend(getDmexLendContract().methods.pledgeNtfs, [nftlist], options);
//     let gasPricePromise = $web3js.getGasPrice();

//     let [e1, gas] = await $utils.awaitWrap(gasPromise);
//     let [e2, gasPrice] = await $utils.awaitWrap(gasPricePromise);
//     if (!!e1) {
//         Vue.prototype.$toast(e1 && e1.message ? e1.message : e1);
//         return null;
//     }

//     let fee = $web3js.fromWei(Vue.prototype.$numberUtils.mul(gasPrice, gas));
//     return { gas, gasPrice, fee };
// }

const DmexLendlend = async([_fpoolPid, NftPledgeInfo], options, callback) => {
    // console.log(NftPledgeInfo)
    // return
    NftPledgeInfo = JSON.parse(JSON.stringify(NftPledgeInfo))
    NftPledgeInfo.filAmount = await $erc20.toErc20Value(NftPledgeInfo.filAmount, $erc20.getErc20Address("HFIL"))
    NftPledgeInfo.pledgeDmcAmount = await $erc20.toErc20Value(NftPledgeInfo.pledgeDmcAmount, $erc20.getErc20Address("DMC"))
    return $web3js.send(getDmexLendContract().methods.lend, [_fpoolPid, NftPledgeInfo], options, callback);
}
const DmexLendlendEstimateSend = async([_fpoolPid, NftPledgeInfo], options) => {
    NftPledgeInfo = JSON.parse(JSON.stringify(NftPledgeInfo))
    NftPledgeInfo.filAmount = await $erc20.toErc20Value(NftPledgeInfo.filAmount, $erc20.getErc20Address("HFIL"))
    NftPledgeInfo.pledgeDmcAmount = await $erc20.toErc20Value(NftPledgeInfo.pledgeDmcAmount, $erc20.getErc20Address("DMC"))

    let gasPromise = $web3js.estimateSend(getDmexLendContract().methods.lend, [_fpoolPid, NftPledgeInfo], options);
    let gasPricePromise = $web3js.getGasPrice();

    let [e1, gas] = await $utils.awaitWrap(gasPromise);
    let [e2, gasPrice] = await $utils.awaitWrap(gasPricePromise);
    if (!!e1) {
        Vue.prototype.$toast(e1 && e1.message ? e1.message : e1);
        return null;
    }

    let fee = $web3js.fromWei(Vue.prototype.$numberUtils.mul(gasPrice, gas));
    return { gas, gasPrice, fee };
}

const DmexLendrepay = async([_tokenid, _fpoolPid, _filAmount], options, callback) => {
    _filAmount = await $erc20.toErc20Value(_filAmount, $erc20.getErc20Address("HFIL"));
    console.log(_filAmount)
    return $web3js.send(getDmexLendContract().methods.repay, [_tokenid, _fpoolPid, _filAmount], options, callback);
}

const DmexLendrepayEstimateSend = async([_tokenid, _fpoolPid, _filAmount], options) => {
    _filAmount = await $erc20.toErc20Value(_filAmount, $erc20.getErc20Address("HFIL"));

    let gasPromise = $web3js.estimateSend(getDmexLendContract().methods.repay, [_tokenid, _fpoolPid, _filAmount], options);
    let gasPricePromise = $web3js.getGasPrice();

    let [e1, gas] = await $utils.awaitWrap(gasPromise);
    let [e2, gasPrice] = await $utils.awaitWrap(gasPricePromise);
    if (!!e1) {
        Vue.prototype.$toast(e1 && e1.message ? e1.message : e1);
        return null;
    }

    let fee = $web3js.fromWei(Vue.prototype.$numberUtils.mul(gasPrice, gas));
    return { gas, gasPrice, fee };
}

const DmexLendrepayAll = async([_tokenid, _fpoolPid], options, callback) => {
    return $web3js.send(getDmexLendContract().methods.repayAll, [_tokenid, _fpoolPid], options, callback);
}

const DmexLendrepayAllEstimateSend = async([_tokenid, _fpoolPid], options) => {

    let gasPromise = $web3js.estimateSend(getDmexLendContract().methods.repayAll, [_tokenid, _fpoolPid], options);
    let gasPricePromise = $web3js.getGasPrice();

    let [e1, gas] = await $utils.awaitWrap(gasPromise);
    let [e2, gasPrice] = await $utils.awaitWrap(gasPricePromise);
    if (!!e1) {
        Vue.prototype.$toast(e1 && e1.message ? e1.message : e1);
        return null;
    }

    let fee = $web3js.fromWei(Vue.prototype.$numberUtils.mul(gasPrice, gas));
    return { gas, gasPrice, fee };
}


const getDmexLendCalcUnlockNftsInfo = ([tokenids], options) => {
    return $web3js.call(getDmexLendContract().methods.calcUnlockNftsInfo, [tokenids], options);
}

const getDmexLendcalcRepayInfo = async([_user, _filAmount], options) => {
    _filAmount = await $erc20.toErc20Value(_filAmount, $erc20.getErc20Address("HFIL"))
    return $web3js.call(getDmexLendContract().methods.calcRepayInfo, [_user, _filAmount], options, handRepayInfo);
}

const handRepayInfo = async(res) => {
    let index = 0;
    let Interest = res[index++];
    let principal = res[index++];
    let pledgeDmcAmount = res[index++];
    Interest = await $erc20.fromErc20Value(Interest, $erc20.getErc20Address("HFIL"));
    principal = await $erc20.fromErc20Value(principal, $erc20.getErc20Address("HFIL"));
    pledgeDmcAmount = await $erc20.fromErc20Value(pledgeDmcAmount, $erc20.getErc20Address("HFIL"));

    return {
        Interest,
        principal,
        pledgeDmcAmount
    }
}

const getDmexLendgetInterestInfo = ([_user], options) => {
    return $web3js.call(getDmexLendContract().methods.getInterestInfo, [_user], options, handleInterestInfo);
}

const handleInterestInfo = async(res) => {
    let index = 0;
    let totalInterest = res[index++];
    let repayInterest = res[index++];
    totalInterest = await $erc20.fromErc20Value(totalInterest, $erc20.getErc20Address("HFIL"));
    repayInterest = await $erc20.fromErc20Value(repayInterest, $erc20.getErc20Address("HFIL"));
    return {
        totalInterest,
        repayInterest
    }
}

const getDmexLendgetUserInterestIncome = ([_pid, _user], options) => {
    return $web3js.call(getDmexLendContract().methods.getUserInterestIncome, [_pid, _user], options, $web3js.fromWei);
}

const getDmexLendannualizedRate = (options) => {
    return $web3js.call(getDmexLendContract().methods.annualizedRate, [], options);
}

const getDmexLendFPoolLendLimit = ([_fpoolPid], options) => {
    return $web3js.call(getDmexLendContract().methods.getFPoolLendLimit, [_fpoolPid], options, handleFPoolLendLimit);
}

const handleFPoolLendLimit = async(res) => {
    return await $erc20.fromErc20Value(res, $erc20.getErc20Address("HFIL"));
}

const getDmexLendcalcDmcAmountV2 = async([_fpoolPid, _filAmount], options) => {
    _filAmount = await $erc20.toErc20Value(_filAmount, $erc20.getErc20Address("HFIL"));
    return $web3js.call(getDmexLendContract().methods.calcDmcAmountV2, [_fpoolPid, _filAmount], options, handleFPoolLendLimit);
}
const DmexLendunlockNfts = async([tokenids], options, callback) => {
    return $web3js.send(getDmexLendContract().methods.unlockNft, [tokenids], options, callback);
}

const DmexLendunlockNftsEstimateSend = async([tokenids], options) => {
    let gasPromise = $web3js.estimateSend(getDmexLendContract().methods.unlockNft, [tokenids], options);
    let gasPricePromise = $web3js.getGasPrice();

    let [e1, gas] = await $utils.awaitWrap(gasPromise);
    let [e2, gasPrice] = await $utils.awaitWrap(gasPricePromise);
    if (!!e1) {
        Vue.prototype.$toast(e1 && e1.message ? e1.message : e1);
        return null;
    }

    let fee = $web3js.fromWei(Vue.prototype.$numberUtils.mul(gasPrice, gas));
    return { gas, gasPrice, fee };
}

const DmexWithdrawDmc = async([_tokenid], options, callback) => {
    return $web3js.send(getDmexLendContract().methods.withdrawDmc, [_tokenid], options, callback);
}

const DmexWithdrawDmcEstimateSend = async([_tokenid], options) => {
    let gasPromise = $web3js.estimateSend(getDmexLendContract().methods.withdrawDmc, [_tokenid], options);
    let gasPricePromise = $web3js.getGasPrice();

    let [e1, gas] = await $utils.awaitWrap(gasPromise);
    let [e2, gasPrice] = await $utils.awaitWrap(gasPricePromise);
    if (!!e1) {
        Vue.prototype.$toast(e1 && e1.message ? e1.message : e1);
        return null;
    }

    let fee = $web3js.fromWei(Vue.prototype.$numberUtils.mul(gasPrice, gas));
    return { gas, gasPrice, fee };
}

const getDmexgetNftInfo = async([_tokenid], options) => {
    return $web3js.call(getDmexLendContract().methods.getNftInfo, [_tokenid], options, handDmexgetNftInfo);
}

const handDmexgetNftInfo = async(res) => {
    let index = 0;
    let dminer = res[index++];
    let cloudMiner = res[index++];
    let prodid = res[index++];
    let oldTokenid = res[index++];
    let power = res[index++];
    let createTime = res[index++];
    let activeTime = res[index++];
    let expireTime = res[index++];
    let gainBenefits = res[index++];
    let pledgeFilAmount = res[index++];
    let lendFilAmount = res[index++];
    let repayFilAmount = res[index++];
    let pledgeDmcAmount = res[index++];
    let unlockedDmcAmount = res[index++];
    let totalInterest = res[index++];
    let repayInterest = res[index++];
    let lastGainedBlock = res[index++];
    let nftIncomeMask = res[index++];
    let nftIncomeRecv = res[index++];
    let nftInterestMask = res[index++];
    let nftInterestRecv = res[index++];
    let nftCapitalMask = res[index++];
    let nftCapitalRecv = res[index++];

    gainBenefits = await $erc20.fromErc20Value(gainBenefits, $erc20.getErc20Address("HFIL"));
    pledgeFilAmount = await $erc20.fromErc20Value(pledgeFilAmount, $erc20.getErc20Address("HFIL"));
    lendFilAmount = await $erc20.fromErc20Value(lendFilAmount, $erc20.getErc20Address("HFIL"));
    repayFilAmount = await $erc20.fromErc20Value(repayFilAmount, $erc20.getErc20Address("HFIL"));
    unlockedDmcAmount = await $erc20.fromErc20Value(unlockedDmcAmount, $erc20.getErc20Address("DMC"));
    pledgeDmcAmount = await $erc20.fromErc20Value(pledgeDmcAmount, $erc20.getErc20Address("DMC"));
    totalInterest = await $erc20.fromErc20Value(totalInterest, $erc20.getErc20Address("HFIL"));
    repayInterest = await $erc20.fromErc20Value(repayInterest, $erc20.getErc20Address("HFIL"));
    lastGainedBlock = await $erc20.fromErc20Value(lastGainedBlock, $erc20.getErc20Address("HFIL"));
    nftIncomeMask = await $erc20.fromErc20Value(nftIncomeMask, $erc20.getErc20Address("HFIL"));
    nftIncomeRecv = await $erc20.fromErc20Value(nftIncomeRecv, $erc20.getErc20Address("HFIL"));
    nftInterestMask = await $erc20.fromErc20Value(nftInterestMask, $erc20.getErc20Address("HFIL"));
    nftInterestRecv = await $erc20.fromErc20Value(nftInterestRecv, $erc20.getErc20Address("HFIL"));
    nftCapitalMask = await $erc20.fromErc20Value(nftCapitalMask, $erc20.getErc20Address("HFIL"));
    nftCapitalRecv = await $erc20.fromErc20Value(nftCapitalRecv, $erc20.getErc20Address("HFIL"));
    return {
        dminer,
        cloudMiner,
        prodid,
        oldTokenid,
        power,
        createTime,
        activeTime,
        expireTime,
        gainBenefits,
        pledgeFilAmount,
        lendFilAmount,
        repayFilAmount,
        pledgeDmcAmount,
        unlockedDmcAmount,
        totalInterest,
        repayInterest,
        lastGainedBlock,
        nftIncomeMask,
        nftIncomeRecv,
        nftInterestMask,
        nftInterestRecv,
        nftCapitalMask,
        nftCapitalRecv
    }
}
export default {
    getDmexLendAddress,
    getDmexLendContract,
    getDmexLendNftInfo,
    getDmcRepayInfos,
    // getDmexLendUserInfo,
    getDmexLendPoolInfo,
    // DmexLendpledge,
    // DmexLendpledgeEstimateSend,
    // DmexLendpledgeNtfs,
    // DmexLendpledgeNtfsEstimateSend,
    DmexLendlend,
    DmexLendlendEstimateSend,
    DmexLendrepay,
    DmexLendrepayEstimateSend,
    DmexLendunlockNfts,
    DmexLendunlockNftsEstimateSend,
    getDmexLendCalcUnlockNftsInfo,
    getDmexLendcalcRepayInfo,
    getDmexLendgetInterestInfo,
    getDmexLendgetUserInterestIncome,
    getDmexLendannualizedRate,
    getDmexLendFPoolLendLimit,
    getDmexLendcalcDmcAmountV2,
    DmexLendrepayAll,
    DmexLendrepayAllEstimateSend,
    DmexWithdrawDmc,
    DmexWithdrawDmcEstimateSend,
    DmexcalcHalfHourInterest,
    getDmexLendAutopayRemainBenefit,
    DmexLendwithdrawRemainBenefit,
    DmexLendwithdrawRemainBenefitEstimate

}



// WEBPACK FOOTER //
// ./src/lib/contract/dmexLend/index.js